import {
    Validators,
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { AuthGuard } from './../../authGuardClass';
import { Router, ActivatedRoute } from '@angular/router';
import { ComponentsService } from 'src/app/components.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RetypedValidator } from './retyped.validator';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DH_CHECK_P_NOT_SAFE_PRIME } from 'constants';
import { el } from 'date-fns/locale';
import { userRequest } from './types/user';

@Component({
    selector: 'app-user-man',
    templateUrl: './user-man.component.html',
    styleUrls: ['./user-man.component.scss']
})
export class UserManComponent implements OnInit, OnDestroy {
    ELEMENT_DATA: UserPreviewTable[] = [];

    dataSource;
    displayedColumns: string[];

    paramsSub;
    loadedParams: boolean = false;
    params;
    clientUuid;

    admin: boolean = false;
    user_id: number = 0;
    retyped_invalid: boolean = false;
    shops: number[] = [];
    userForm: FormGroup;
    displayMessage: boolean = false;
    displayErrMessage: boolean = false;
    addUser: boolean = false;
    editUser: boolean = false;
    message: string;
    userShops: Array<number> = [];
    submitted: boolean = false;
    paramsVar;
    usersVar;
    shopsVar;
    clientChangeVar;
    refreshVar;
    superAdmin: boolean = false;

    confirmResult: boolean = false;
    confirmResultMessage: string = '';

    showConfirmDialog: boolean = false;
    pendingUserId: number | null = null;

    checkAll: boolean = false;
    superAdminObj = {
        user_id: 0,
        name: '',
        last_name: '',
        username: '',
        admin: 0,
        shopname: '',
        location_code: 0,
        selected: false,
        active: 0,
        clientUuid: 0
    };
    superAdminSub;
    adminClient;
    userShopId = 0;

    private userForEdit: any;

    private adminSubscr: Subscription;
    private super_adminSubscr: Subscription;
    private attnSubscr: Subscription;
    private shop_mngrSubscr: Subscription;

    constructor(
        private service: ComponentsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authGuard: AuthGuard,
        private fb: FormBuilder,
        public dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.clientUuid = this.service.getUsersPerm().clientUuid;
        this.superAdmin = this.service.getUsersPerm().superAdmin;

        this.displayedColumns = [
            'user_id',
            'name',
            'last_name',
            'username',
            'active'
        ];
        if (this.superAdmin) {
            this.displayedColumns.splice(4, 0, 'admin');
            this.displayedColumns.splice(5, 0, 'superAdmin');
        }

        this.loadUsers();

        this.paramsVar = this.activatedRoute.params.subscribe((params) => {
            this.params = params;
            this.loadedParams = true;
            this.clientUuid = this.service.getUsersPerm().clientUuid;
            this.superAdmin = this.service.getUsersPerm().superAdmin;
            // }
        });

        //KADA SE MENJA KLIJENT (  SUPER ADMIN );
        this.refreshVar = this.service.refreshPage.subscribe(() => {
            this.loadUsers();
        });

        // Listen to client changes
        this.clientChangeVar = this.service.clientChanged.subscribe(() => {
            this.clientUuid = this.service.getUsersPerm().clientUuid;
            this.cancel(); // Close any open forms
            this.loadUsers();
        });
    }

    loadUsers(): void {
        this.service
            .requestUsersMulti(
                this.clientUuid,
                this.service.getUsersPerm(),
                this.superAdmin
            )
            .subscribe((data) => {
                this.adminClient = data[1].clientUuid;
                this.superAdminObj = {
                    user_id: data[1].user_id,
                    name: data[1].name,
                    last_name: data[1].last_name,
                    username: data[1].username,
                    admin: data[1].admin,
                    shopname: data[1].shopname,
                    location_code: data[1].location_code,
                    selected: false,
                    active: data[1].active,
                    clientUuid: data[1].clientUuid
                };
                this.service.loadingUsers.emit({
                    message: '',
                    loaded: true
                });
                this.formUserTable(data[0]);
            });
    }

    refreshData() {
        this.service.loadingUsers.emit({
            message: 'Loading. . .',
            loaded: false
        });
        this.service.refreshPage.emit();
    }

    ngOnDestroy() {
        this.newRolesUnsubscribe();

        if (this.paramsVar) {
            this.paramsVar.unsubscribe();
        }

        if (this.usersVar) {
            this.usersVar.unsubscribe();
        }

        if (this.shopsVar) {
            this.shopsVar.unsubscribe();
        }

        if (this.clientChangeVar) {
            this.clientChangeVar.unsubscribe();
        }

        if (this.superAdminSub) {
            this.superAdminSub.unsubscribe();
        }
    }
    newRolesUnsubscribe() {
        if (this.adminSubscr) {
            this.adminSubscr.unsubscribe();
        }
        if (this.super_adminSubscr) {
            this.super_adminSubscr.unsubscribe();
        }
        if (this.attnSubscr) {
            this.attnSubscr.unsubscribe();
        }
        if (this.shop_mngrSubscr) {
            this.shop_mngrSubscr.unsubscribe();
        }
    }

    formUserTable(users) {
        if (!users.length) {
            this.ELEMENT_DATA = [];
            this.dataSource = new MatTableDataSource<UserPreviewTable>(
                this.ELEMENT_DATA
            );
        }

        /*if(this.clientUuid != this.adminClient && this.superAdmin) {
      users.push(this.superAdminObj);
    }*/
        if (Array.isArray(users)) {
            users.sort((a, b) => a.user_id - b.user_id);
            this.ELEMENT_DATA = users;
            this.dataSource = new MatTableDataSource<UserPreviewTable>(
                this.ELEMENT_DATA
            );
        } else {
            // Handle the case when users is not an array
            console.error('users is not an array');
        }
        // users.sort((a, b) => { return a.user_id - b.user_id })
        // for (let i = 0; i < users.length; i++) {
        //   this.ELEMENT_DATA = users;
        //   this.dataSource = new MatTableDataSource<UserPreviewTable>(this.ELEMENT_DATA);
        // }
    }

    check(row) {
        this.ELEMENT_DATA.forEach((item) => {
            item.selected = false;
        });
        row.selected = true;
    }

    getUserInfo(row) {
        this.userForEdit = row;
    }

    onRowClick(row) {
        this.check(row);
        this.getUserInfo(row);
        this.onEdit();
    }

    cleanUserForm() {
        this.addUser = false;
        this.newRolesUnsubscribe();
        this.userForm = this.fb.group(
            {
                user_id: this.fb.control(0),
                clientUuid: this.fb.control(this.clientUuid),
                name: this.fb.control('', [Validators.required]),
                last_name: this.fb.control('', [Validators.required]),
                username: this.fb.control('', [Validators.required]),
                password: this.fb.control('', [Validators.required]),
                retyped_password: this.fb.control('', [Validators.required]),
                userRole: this.fb.control('admin'),
                active: this.fb.control(true)
            },
            {
                validators: RetypedValidator('password', 'retyped_password')
            }
        );

        this.user_id = 0;
    }

    onAdd() {
        this.cleanUserForm();
        this.addUser = true;
    }

    onEdit() {
        if (this.userForEdit === undefined) {
            this.displayErrMessage = true;
            this.message = `Select user for edit`;
            this.fadeOutMessage();
            return;
        }
        this.cleanUserForm();
        this.editUser = true;
        this.userForm.get('username').disable();

        this.user_id = this.userForEdit.user_id;
        this.userForm.get('user_id').setValue(this.userForEdit.userId);
        this.userForm.get('name').setValue(this.userForEdit.name);
        this.userForm.get('last_name').setValue(this.userForEdit.lastName);
        this.userForm.get('username').setValue(this.userForEdit.username);
        this.userForm.get('password').setValue(this.userForEdit.password);
        this.userForm
            .get('userRole')
            .setValue(this.userForEdit.superAdmin ? 'superAdmin' : 'admin');
        this.userForm
            .get('retyped_password')
            .setValue(this.userForEdit.password);
        this.userForm.get('active').setValue(this.userForEdit.active);
    }

    cancel() {
        this.addUser = false;
        this.editUser = false;
    }

    checkError(controlName: string, errorName: string) {
        return this.userForm.controls[controlName].hasError(errorName);
    }

    get f() {
        return this.userForm.controls;
    }

    fadeOutMessage() {
        if (this.displayMessage) {
            setTimeout(() => {
                this.displayMessage = false;
            }, 10000);
        }

        if (this.displayErrMessage) {
            setTimeout(() => {
                this.displayErrMessage = false;
            }, 10000);
        }

        if (this.confirmResult) {
            setTimeout(() => {
                this.confirmResult = false;
            }, 10000);
        }
    }

    changeShop(value) {
        this.userForm.get('shop_id').setValue(value);
    }

    getAfterFirstComma(input) {
        if (input == '') {
            return;
        } else {
            let parts = input.split(',');
            return parts[1];
        }
    }

    async onSubmit() {
        try {
            this.submitted = true;
            let message = '';

            if (this.userForm.invalid) {
                this.displayErrMessage = true;
                this.message = `Invalid user form`;
                this.fadeOutMessage();
                return;
            }

            const formValues = this.userForm.getRawValue();

            const user: userRequest = {
                active: formValues.active,
                clientUuid: formValues.clientUuid,
                lastName: formValues.last_name,
                name: formValues.name,
                password: formValues.password,
                userRole: formValues.userRole,
                username: formValues.username
            };
            if (this.editUser) {
                await this.service.updateUser(user);
                message = 'User updated successfully';
            }

            if (this.addUser) {
                await this.service.insertUser(user);
                message = 'User created successfully';
            }

            const users = await this.service.getUsers(
                this.clientUuid,
                this.superAdmin
            );
            this.formUserTable(users);

            this.confirmResult = true;
            this.confirmResultMessage = message;
        } catch (error) {
            this.displayErrMessage = true;
            this.message = 'Action unsuccessfull!';
        } finally {
            this.fadeOutMessage();
            this.addUser = false;
            this.editUser = false;
        }
    }
}

export interface UserPreviewTable {
    user_id: number;
    name: string;
    last_name: string;
    username: string;
    admin: boolean;
    shopname: string;
    location_code: number;
    selected: boolean;
    active: boolean;
}
